import { ExerciseData, ExerciseViewProps } from '../../exercises';
import React from 'react';
import { Exercise } from '../../components';
import { StressedEnough } from '../../../articles/StressedEnough';

export const exerciseData94: ExerciseData = {
    ExerciseView: IntroModuleExercise4,
    dataKeys: [],
    questions: [],
};

function IntroModuleExercise4() {
    return (
        <Exercise title="Hvornår er jeg stresset nok?">
            <StressedEnough />
        </Exercise>
    );
}
